import { render, staticRenderFns } from "./ProductActionReindex.vue?vue&type=template&id=1c181b11&"
import script from "./ProductActionReindex.vue?vue&type=script&lang=ts&"
export * from "./ProductActionReindex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports